import React from 'react';
import {
  TableRow, TableCell, Box, Table, TableBody, Typography,
} from '@mui/material';
import { uid } from 'react-uid';
import PropTypes from 'prop-types';
import TableHead from '../../common/TableHead';

const headCells = [
  {
    id: 'fund',
    numeric: false,
    disablePadding: false,
    label: 'FUND',
  },
  {
    id: 'portfolioCompany',
    numeric: false,
    disablePadding: false,
    label: 'PORTFOLIO COMPANY',
  },
  {
    id: 'amount',
    numeric: true,
    disablePadding: false,
    label: 'AMOUNT',
  },
];

const PaidDistributionsDetailsRow = ({ row }) => (
  <TableRow sx={{ backgroundColor: '#F6F6F6' }}>
    <TableCell colSpan={6} align="center" sx={{ p: 2 }}>
      <Box
        sx={{
          border: '2px solid #E7E7E2',
          borderRadius: '8px',
          overflow: 'hidden',
          maxWidth: '80%',
          margin: '0 auto',
        }}
      >
        <Table>
          <TableHead headCells={headCells} backgroundColor="white" />
          <TableBody>
            {row.subDistributions.map((detail, detailIndex) => (
              <TableRow
                key={uid(detail)}
                sx={{
                  backgroundColor: detailIndex % 2 === 0 ? '#F5F1F9' : 'white',
                }}
              >
                <TableCell
                  sx={{
                    border: 'none', // Remove border from individual cells
                  }}
                >
                  {detail.fundName}
                </TableCell>
                <TableCell
                  sx={{
                    border: 'none',
                  }}
                >
                  {detail.companyName}
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: 'right',
                    border: 'none',
                  }}
                >
                  {detail.amount}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

      </Box>
    </TableCell>
  </TableRow>
);

PaidDistributionsDetailsRow.propTypes = {
};

export default PaidDistributionsDetailsRow;
